
// 全局store
let globalStore = null;

module.exports = {
    /**
     * 保存全局store
     */
    saveGlobalStore(store) {
        globalStore = store;
    },

    registerModule(name) {
        globalStore.registerModule(name, {
            namespaced: true,
            state: {
                visible: false,
                closedCallback: null,
                data: null
            },
            mutations: {
                open(state, payload) {
                    state.visible = true

                    if (payload) {
                        state.closedCallback = payload && payload.closedCallback

                        // 利用序列化和反序列化进行深拷贝，防止对原有数据的修改
                        if (payload.data) {
                            state.data = JSON.parse(JSON.stringify(payload.data));
                        }
                    }
                },
                close(state) {
                    // 执行关闭弹窗的回调函数
                    state.closedCallback && state.closedCallback()
                    state.visible = false
                    state.data = null
                }
            },
            getters: {
                visible: (state) => {
                    return state.visible
                },
                data: (state) => {
                    //console.log("state.data", state.data)
                    return state.data
                },
            }
        })
    },

    visible(name) {
        return globalStore.getters[name + '/visible']
    },

    getData(name) {
        return globalStore.getters[name + '/data']
    },

    /**
     * 打开对话框
     * @param {*} name 
     * @param {*} params 
     */
    open(name, params) {
        globalStore.commit(name + '/open', params)
    },

    /**
     * 关闭对话框
     * @param {*} name 
     */
    close(name) {
        globalStore.commit(name + '/close')
    },
}